import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "provider/AuthContext";
import { UserSettingsProvider } from "provider/UserSettingsContext";
import { GamePlayProvider } from "provider/GamePlayContext";
import { SportsbookProvider } from "provider/SportsbookContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <SportsbookProvider>
        <UserSettingsProvider>
          <GamePlayProvider>
            <App />
          </GamePlayProvider>
        </UserSettingsProvider>
      </SportsbookProvider>
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
